/**
 * @file STRV logo — the standard's wordmark (src/standard/js/logo.js) as a
 * fresh SVG element per render (an SVG node can't sit in two parents). It
 * takes the accent colour: STRV red, magenta in the arcade theme.
 */

import { strvLogo as logoMarkup } from './standard/js/logo.js';
import { svgFromStandard } from './lib/svg.js';

/** Returns a fresh SVGElement for embedding. */
export function strvLogo() {
  return svgFromStandard(logoMarkup());
}
